import React from 'react';
import AuthStyle from 'Style/AuthStyle';
import FreshBotStyle from 'Style/FreshBotStyle';
import GoogleTranslatorStyle from 'Style/GoogleTranslatorStyle';

type Props = {
  showAuthStyle: boolean;
  showTranslatorStyle: boolean;
  showFreshBotStyle: boolean;
};

/**
 * Non-critical global styles loaded only when their UI is mounted.
 */
const DeferredAppStyles = function DeferredAppStyles({
  showAuthStyle,
  showTranslatorStyle,
  showFreshBotStyle,
}: Props) {
  return (
    <>
      {showAuthStyle ? <AuthStyle /> : null}
      {showTranslatorStyle ? <GoogleTranslatorStyle /> : null}
      {showFreshBotStyle ? <FreshBotStyle /> : null}
    </>
  );
};

export default DeferredAppStyles;
